export const USA_COORDS = {
  latitude: 39.550051,
  longitude: -105.782067,
  formattedAddress: '',
};
